import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6732D314-97CA-4433-9CB5-260359AC131F
 * name home-floor-0
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-0.svg
 * tags
 * - Home Automation 
 */
export const HomeFloor0Icon = createSvgIcon(<><path d="M11,10H13V16H11V10M22,12H19V20H5V12H2L12,3L22,12M15,10A2,2 0 0,0 13,8H11A2,2 0 0,0 9,10V16A2,2 0 0,0 11,18H13A2,2 0 0,0 15,16V10Z" /></>, 'HomeFloor0Icon');
export default HomeFloor0Icon